import { render, staticRenderFns } from "./SampleTypeDropdown.vue?vue&type=template&id=5aaf4634&scoped=true"
import script from "./SampleTypeDropdown.vue?vue&type=script&lang=js"
export * from "./SampleTypeDropdown.vue?vue&type=script&lang=js"
import style0 from "./SampleTypeDropdown.vue?vue&type=style&index=0&id=5aaf4634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf4634",
  null
  
)

export default component.exports